import React, { useState } from 'react';
import ProductActions from '@Actions/productActions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Lottie from 'lottie-react';
import { notification } from 'antd';
import scannerLottie from '../../../media/lotties/scanner.json';
import error from '../../../media/audio/error.mp3';
import success from '../../../media/audio/success.mp3';
import './style.scss';

function Scanner({
  user, searchProducts, searchProductsSuccess, tenantDepartmentId, selectedTenant, excludedProducts,
  excludeOutOfStock, productTypes, isSalesProduct, isPurchaseProduct, filterReservedQuantity, onSearch, toggleScanner,
}) {
  const [inputValue, setInputValue] = useState('');
  const audioError = new Audio(error);
  const audioSuccess = new Audio(success);
  return (
    <div className="scanner-active">
      <Lottie
        animationData={scannerLottie}
        loop
      />
      <input
        autoFocus
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            searchProductsSuccess(null);
            searchProducts({
              keyword: '',
              tenantId: selectedTenant || user?.tenant_info?.tenant_id,
              stockStatus: null,
              page: 1,
              limit: 30,
              tenantDepartmentId: tenantDepartmentId || '',
              excludeOutOfStock,
              productType: productTypes?.join(','),
              category: null,
              isSalesProduct,
              isPurchaseProduct,
              search: true,
              filterReservedQuantity,
              barcode: event.target.value,
            }, (tenantSku) => {
              if (tenantSku && !excludedProducts.includes(tenantSku?.product_sku_id?.toString()) && (tenantSku?.barcode_batch_id ? tenantSku?.product_batches?.find((i) => i?.batch_id === tenantSku?.barcode_batch_id) : true)) {
                audioSuccess.play();
                onSearch(tenantSku);
              } else {
                audioError.play();
                if (excludedProducts.includes(tenantSku?.product_sku_id?.toString())) {
                  notification.open({
                    message: 'Product has already been scanned',
                    placement: 'top',
                    type: 'error',
                    duration: 4,
                  });
                } else
                if (tenantSku?.barcode_batch_id && !tenantSku?.product_batches?.find((i) => i?.batch_id === tenantSku?.barcode_batch_id)) {
                  notification.open({
                    message: 'The batch you have scanned has already been consumed or is reserved for other orders.',
                    placement: 'top',
                    type: 'error',
                    duration: 4,
                  });
                } else {
                  notification.open({
                    message: 'We could not find the right product. Please try again.',
                    placement: 'top',
                    type: 'error',
                    duration: 4,
                  });
                }
              }
              setInputValue('');
            });
          }
        }}
        onBlur={() => toggleScanner()}
      />
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  searchResults: ProductReducers.searchResults,
  searchProductsLoading: ProductReducers.searchProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  searchProducts: (params, callback) => dispatch(ProductActions.searchProducts(params, callback)),
  searchProductsSuccess: (searchResults) => dispatch(ProductActions.searchProductsSuccess(searchResults)),
});

Scanner.propTypes = {
  user: PropTypes.any,
  searchProducts: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Scanner));
